"use client";

import { useCart } from "@/context/CartContext";

function ShoppingBagIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-5 w-5"
        >
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <path d="M16 10a4 4 0 0 1-8 0" />
        </svg>
    );
}

export default function CartButton() {
    const { setOpen, totalItems } = useCart();

    return (
        <button
            onClick={() => setOpen(true)}
            className="relative cursor-pointer rounded-full border border-primary-light p-2.5 text-primary-dark transition hover:border-primary hover:text-primary"
            aria-label="Buka keranjang"
        >
            <ShoppingBagIcon />
            {totalItems > 0 && (
                <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-[10px] font-semibold text-white">
                    {totalItems > 99 ? "99+" : totalItems}
                </span>
            )}
        </button>
    );
}
